import { useQuery } from "@blitzjs/rpc"
import getPipelinesTranslationsDiff from "../queries/getPipelinesTranslationsDiff"
import { partition } from "lodash"

export default function useBulkDeployPipelines(selectedPipelineIds: number[], enabled: boolean) {
  const [pipelinesTranslationsDiff] = useQuery(getPipelinesTranslationsDiff, selectedPipelineIds, {
    cacheTime: 0,
    enabled,
  })

  const [errorPipelineIds, validPipelineIds] = partition(pipelinesTranslationsDiff, function (o) {
    return o.isError
  })
  const errorPipeIds = errorPipelineIds.map((obj) => obj.pipelineId)
  const diffPipeIds = validPipelineIds.filter((obj) => obj.isDiff).map((obj) => obj.pipelineId)
  const diffKeys = validPipelineIds
    .filter((obj) => obj.isDiff)
    .map((obj) => {
      return {
        pipelineId: obj.pipelineId,
        diffKeys: obj.diffKeys,
      }
    })
  const samePipeIds = validPipelineIds.filter((obj) => !obj.isDiff).map((obj) => obj.pipelineId)

  return {
    errorPipeIds,
    validPipelineIds,
    diffPipeIds,
    diffKeys,
    samePipeIds,
  }
}
